import NotificationComponent from './NotificationComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { dismissNotification } from 'actions/notification/notification';
import { getTopNotifications } from 'actions/notification/selectors';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => {
  return {
    notifications: getTopNotifications(state)
  };
};

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ dismissNotification }, dispatch);
};

// Create higher-order component which feeds in specified props.
const NotificationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationComponent);

export default NotificationContainer;



// WEBPACK FOOTER //
// ./src/components/common/Notification/NotificationContainer.js